import { render } from "./removeTransactionPopup.vue?vue&type=template&id=24e00544&scoped=true"
import script from "./removeTransactionPopup.vue?vue&type=script&lang=js"
export * from "./removeTransactionPopup.vue?vue&type=script&lang=js"

import "./removeTransactionPopup.vue?vue&type=style&index=0&id=24e00544&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e00544"]])

export default __exports__